import { CUSTOM_SEARCH_FIELDS } from './customOrderSearch';

// Like recent global searches, this is remembered in this browser, without cookies.
export const LAST_CUSTOM_SEARCH_KEY = 'globalSearch_lastCustomSearch';

export interface LastCustomSearch {
  searchBy: string;
  text: string;
  includeDeleted: boolean;
  viewId: string;
}

export function loadLastCustomSearch(): LastCustomSearch | null {
  try {
    const raw = localStorage.getItem(LAST_CUSTOM_SEARCH_KEY);
    if (!raw) return null;
    const saved: unknown = JSON.parse(raw);
    if (!saved || typeof saved !== 'object') return null;
    const { searchBy, text, includeDeleted, viewId } = saved as Partial<LastCustomSearch>;
    if (
      !CUSTOM_SEARCH_FIELDS.some((field) => field.value === searchBy) ||
      typeof text !== 'string' ||
      typeof includeDeleted !== 'boolean' ||
      typeof viewId !== 'string'
    ) return null;
    return { searchBy: searchBy!, text, includeDeleted, viewId };
  } catch {
    // Corrupt or blocked storage should leave the usual empty search form.
    return null;
  }
}

export function saveLastCustomSearch(search: LastCustomSearch): void {
  try {
    localStorage.setItem(LAST_CUSTOM_SEARCH_KEY, JSON.stringify(search));
  } catch {
    // Storage may be full or blocked; the search must still run.
  }
}
